import { regexes, vowels } from '@/config/constants';

// for this logic, used:
// https://codepoints.net/hebrew
// http://www.unicode.org/charts/PDF/U0590.pdf
// can also be helpful:
// https://www.safa-ivrit.org/alphabet/howto_win.php

const stripVowels = rawString =>
  rawString.replace(regexes.vowelsRegex, '').trim();

const isCharacterVowel = char => regexes.vowelsRegex.test(char);

const isChracterShin = char => regexes.shinRegex.test(char);

const isCharacterVav = char => regexes.vavRegex.test(char);

const isCharacterDageshCorrection = char =>
  regexes.correctDageshLettersRegex.test(char);

const isCharacterDagesh = char => regexes.VOWEL_U_VAV.test(char);

const detectVowelOnText = (wordArr, i) => {
  if (regexes.VOWEL_A.test(wordArr[i])) {
    return vowels.VOWEL_A;
  }
  if (regexes.VOWEL_O.test(wordArr[i])) {
    return vowels.VOWEL_O;
  }
  if (regexes.VOWEL_I.test(wordArr[i])) {
    return vowels.VOWEL_I;
  }
  if (regexes.VOWEL_E.test(wordArr[i])) {
    return vowels.VOWEL_E;
  }
  if (
    // vowel is שורוק or vav with דגש dagesh
    regexes.VOWEL_U.test(wordArr[i]) ||
    (isCharacterDagesh(wordArr[i]) && isCharacterVav(wordArr[i - 1]))
  ) {
    return vowels.VOWEL_U;
  }
  if (regexes.VOWEL_SHVA.test(wordArr[i])) {
    return vowels.VOWEL_SHVA;
  }
};

const findNextVowel = (paintedChars, wordArr) => {
  let vowelsCounter = 0;
  for (let i = 0; i < wordArr.length; i++) {
    const detectedVowel = detectVowelOnText(wordArr, i);
    if (detectedVowel) {
      if (vowelsCounter === paintedChars) {
        return detectedVowel;
      }
      vowelsCounter++;
    }
  }
  return '';
};

const getRandomItems = (arr, itemsAmount = 5) => {
  const randomItems = [];
  for (let i = 0; i < itemsAmount; i++) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    randomItems.push(arr[randomIndex]);
    arr.splice(randomIndex, 1);
  }
  return randomItems;
};

export default {
  stripVowels,
  isCharacterVowel,
  isChracterShin,
  isCharacterVav,
  isCharacterDageshCorrection,
  isCharacterDagesh,
  findNextVowel,
  getRandomItems
};
